import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Permission } from './permission.model';
import { config } from '../../../../config';

@Injectable()
export class PermissionService {
  private endpoint: string = `${config.apiLocation}/admin/permissions`;

  constructor(private http: HttpClient) {}

  get(): Observable<Permission[]> {
    return this.http
      .get<{ data: Permission[] }>(`${this.endpoint}`)
      .map(res => res.data);
  }

  getById(id): Observable<Permission> {
    return this.http
      .get<{ data: Permission }>(`${this.endpoint}/${id}`)
      .map(res => res.data);
  }

  create(permission: Permission): Observable<Permission> {
    return this.http
      .post<{ data: Permission }>(`${this.endpoint}`, permission)
      .map(res => res.data);
  }

  update(permission: RecursivePartial<Permission>): Observable<Permission> {
    return this.http
      .patch<{ data: Permission }>(`${this.endpoint}/${permission.id}`, permission)
      .map(res => res.data);
  }

  delete(permissionId: string) {
    return this.http.delete<void>(`${this.endpoint}/${permissionId}`, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/permissions/permission.service.ts